import { IGlossary, IHyperlink, IItemBase, ITeaser } from '@shared/interfaces';
import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CacheService } from '@shared/services/cache.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export class ItemsDirective implements OnInit, OnDestroy {
    public teaserBox1: ITeaser = {
        format: 12,
        fontSizeHeader: 23,
        backgroundColor: 'linear-gradient(90deg, #198cb9 0%, #2db4e1 52.7%, #0099B0 84.46%, #198cb9 100%)',
        fontColorHeader: '#fff',
        fontColorText: '#fff'
    };

    public teaserBox2: ITeaser = {
        format: 12,
        fontSizeHeader: 23,
        backgroundColor: '#196482',
        fontColorHeader: '#50BED7',
        fontColorText: '#50BED7'
    };

    public teaserItems: { teaser: ITeaser; item: IItemBase }[];
    public currentLanguage = this.translateService.currentLang;
    public selectedItem: IHyperlink | IGlossary;
    public items: Array<IHyperlink | IGlossary>;

    subscription: Subscription[] = [];

    constructor(
        private changeDetection: ChangeDetectorRef,
        public cache: CacheService,
        private router: Router,
        private translateService: TranslateService
    ) {}

    async ngOnInit() {
        this.loadData();

        this.subscription.push(
            this.translateService.onLangChange.subscribe(e => {
                this.currentLanguage = e.lang;
                this.convertToTeaserItems();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.forEach(e => e.unsubscribe());
    }

    public loadData() {
        this.convertToTeaserItems();
    }

    public teaserItem(item: IHyperlink, index: number): { teaser: ITeaser; item: IHyperlink } {
        return {
            teaser: {
                ...(index % 2 === 0 ? this.teaserBox1 : this.teaserBox2),
                title: this.currentLanguage === 'en' ? item.title : item.titleDe,
                externalLink: item.urlLink
            },
            item
        };
    }

    public selectItem(item: IGlossary) {
        this.selectedItem = item === this.selectedItem ? null : item;
    }

    private convertToTeaserItems() {
        const titleColumn = this.currentLanguage === 'en' ? 'title' : 'titleDe';
        console.log(titleColumn);
        this.teaserItems = this.items
            // .sort((a, b) => a[titleColumn].localeCompare(b[titleColumn]))
            .reduce((all, one, i) => {
                const ch = Math.floor(i / 4);
                all[ch] = [].concat(all[ch] || [], one);
                return all;
            }, [] as ITeaser[][])
            .map(e => e.map((a, i) => this.teaserItem(a, i)))
            // .map((e, i) => i % 2 === 0 ? e : e.reverse())
            .reduce((all, item) => all.concat(item), []);
    }
}
